export default {
  methods: {
    $_moneyFormatter(num) {
      return new Intl.NumberFormat('ru-Ru', { style: 'currency', currency: 'UZS' }).format(num)
    },
    $_dateTimeFormatter(date) {
      return new Date(date).toLocaleString()
    },
    $_convertToBase64(element) {
      console.log(element)
      return new Promise((resolve, reject) => {
        // const file = element
        const reader = new FileReader()
        reader.readAsDataURL(element)
        reader.onloadend = function () {
          resolve(reader.result)
        }
        reader.onerror = error => reject(error)
      })
    },
  },
}
